import { IconButton, makeStyles } from '@material-ui/core'
import React, { FC } from 'react'
import { generatePath, useHistory, useParams, useRouteMatch } from 'react-router-dom'

interface MenuItemProps {
  route: string
  icon: FC<any>
  onClick?: () => void
}

export function MenuItem(props: MenuItemProps) {
  const classes = useStyles()
  const selected = useRouteMatch(props.route)
  const history = useHistory()
  const params = useParams()
  const gotoPath = generatePath(props.route, params)

  const handleClick = () => {
    if (props.onClick) props.onClick()
    else history.push(selected ? './' : gotoPath)
  }

  return (
    <IconButton
      TouchRippleProps={{ className: classes.rippleRoot }}
      className={classes.button}
      style={selected ? { background: '#333' } : undefined}
      onClick={handleClick}
    >
      <props.icon style={{ color: selected ? '#F7A63D' : '#FFF' }} />
    </IconButton>
  )
}

const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: 0,
    // [theme.breakpoints.down(theme.spacing(51))]: {
    //   padding: theme.spacing(1.5, 0.25),
    // },
  },
  rippleRoot: {
    '.MuiTouchRipple-child': {
      backgroundColor: 'blue',
      opacity: 1,
    },
  },
}))
